<template>
  <Dialog
    :close-on-escape="false"
    :closable="false"
    class="dialog-without-title dialog-content-p-0"
    v-model:visible="visible"
    :style="{width: '648px'}"
    :modal="true"
  >
    <div class="congratulations-wrapper">
      <Congratulations width="450px"/>
    </div>

    <div class="payment-successful-modal-wrapper-inner">
      <h4 class="payment-successful-modal-title">Woohoo!</h4>
      <div class="payment-successful-modal-text" v-html="textMessage"></div>
      <div class="payment-successful-modal-buttons p-fluid">
        <Button :label="successButtonLabel" class="p-button-md" @click="successAction"/>
      </div>
    </div>

    <template #footer/>
  </Dialog>
</template>

<script setup>
import {ref, watch} from "vue";
import {useRouter} from "vue-router";
import Congratulations from '../animations/Congratulations';

const router = useRouter()

const emit = defineEmits(['update:visible', 'successAction']);
const props = defineProps({
  visible: {type: Boolean, default: false, required: true},
  textMessage: {type: String, required: true},
  successButtonLabel: {type: String, required: true},
});

const visible = ref(props.visible);

watch(() => visible, (newValue) => emit('update:visible', newValue))
watch(() => props.visible, (newValue) => visible.value = newValue)

const successAction = () => emit('successAction')
</script>

<style lang="scss" scoped>
@import "../../assets/sass/theme_variables";

.congratulations-wrapper {
  margin-top: -76px;
  margin-bottom: -75px;
}

.payment-successful-modal-wrapper-inner {
  width: toRem(320);
  text-align: center;
  margin: 0 auto;
}

.icon-successful {
  display: inline-block;
}

.payment-successful-modal-title {
  margin-bottom: 0;
  margin-top: toRem(8);
  font-weight: bold;
}

.payment-successful-modal-text {
  margin-top: toRem(5);
  font-size: toRem(18);
}

.payment-successful-modal-buttons {
  display: flex;
  margin-top: toRem(24);
}

</style>
